export default __webpack_public_path__ + "static/media/cp_geo_mt.aeb2f211.svg";